// @flow
import React from 'react'
import classNames from 'classnames'

// components
import { Loader } from '../../../Components/'

type InsuranceCompanyFilterProps = {
  checked: boolean,
  classNames?: string,
  data: { fetching: boolean, webLogoGrey: string, enabled: boolean },
  domain: { name: string, value: string, image: string, shortName: string },
  lgClassesGrid?: boolean,
  onChange: (name: string, checked: boolean) => void,
  parentName?: string,
  textMode: boolean,
  topFilter?: boolean,
}

const InsuranceCompanyFilter = (props: InsuranceCompanyFilterProps) => {
  const handleOnChange = (event: SyntheticInputEvent<HTMLInputElement>) => {
    if (props.data.enabled || props.checked) {
      props.onChange(props.domain.name, event.target.checked)
    }
  }

  if (props.textMode) {
    return props.checked &&
      <div className='d-block d-sm-inline-block pl-4'>
        <strong>{props.domain.shortName}</strong>
      </div>
  }

  const id = `filter-${props.parentName || ''}-${props.domain.name}`
  let classes = [props.classNames ? props.classNames : 'col-4 col-sm-3 col-md-2 col-lg-3 col-xl-6 col-xxl-4 py-2']
  if (props.topFilter) {
    classes = ['col-4 col-sm-3 col-md-2 col-lg-3 col-xl-2 py-2']
  }

  return (
    <div className={classNames(classes)}>
      <div className='custom-control custom-checkbox'>
        <input
          checked={props.checked}
          className='custom-control-input'
          data-hj-whitelist
          id={id}
          onChange={handleOnChange}
          type='checkbox'
        />
        <label
          className='custom-control-label custom-control-label-sm checkbox-middle'
          htmlFor={id}
        >
          <img
            className={(props.data.fetching || !props.data.enabled) ? '' : 'd-none'}
            src={props.data.webLogoGrey}
            style={{ maxHeight: 35 }}
          />
          <img
            className={(props.data.fetching || !props.data.enabled) ? 'd-none' : ''}
            src={props.domain.image}
            style={{ maxHeight: 35 }}
          />
        </label>
        {props.data &&
        <Loader
          active={props.data.fetching && props.data.enabled}
          cover
          small
          type='ball-spin-fade-loader'
        />}
      </div>
    </div>
  )
}

export default InsuranceCompanyFilter
